module.exports = __webpack_public_path__ + "static/media/046.aa169682.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/046.jpg
// module id = 341
// module chunks = 0